
import React from "react";
import TimeCountDown from "../TimeCountDown/TimeCountDown";
import "./style.css";

const Saveday = () => {
  return (
    <div className="count-down-area">
      <div className="count-down-sectionparallax">
        <div className="container">
          <div className="count-down-item count-down-item2">
            <div className="row g-0 align-items-stretch">
              {/* Cột trái: Ảnh kỷ niệm & Khung chữ tình yêu */}
              <div className="col-12 col-lg-5 section-area">
                <div className="section-area-overlay"></div>
                <div className="section-area-frame">
                  <span className="countdown-subtitle">HÀNH TRÌNH CHUNG ĐÔI</span>
                  <h3 className="countdown-title">Bên Nhau Kể Từ</h3>
                  <div className="countdown-date-badge">
                    <span>12.12.2024</span>
                  </div>
                  <div className="countdown-divider"></div>
                  <p className="countdown-desc">
                    “Khoảnh khắc em mỉm cười gật đầu trao cho anh cơ hội đồng hành...”
                  </p>
                </div>
              </div>

              {/* Cột phải: Khối đồng hồ đếm thời gian cân đối */}
              <div className="col-12 col-lg-7 clock-area">
                <div className="clock-area-inner">
                  <div className="clock-header">
                    <span className="clock-badge">💕 CÙNG NHAU ĐI QUA TỪNG KHOẢNH KHẮC</span>
                  </div>
                  <TimeCountDown />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Saveday;
